<template>
    <authenticated-layout>
        <v-card class="pa-6 mx-auto" max-width="600">
            <h1 class="py-2 mb-6 text-xl border-b">
                {{ $t("extraFeaturePricesPanel.Extra feature prices panel") }}
            </h1>

            <form @submit.prevent="onUpdateExtraFeaturePrices">
                <v-text-field
                    v-for="(item, index) in extraFeaturePrices"
                    :key="index"
                    v-model="item.price"
                    :label="formatLabel(item.feature_name)"
                    variant="outlined"
                    density="compact"
                    type="input"
                />

                <v-btn
                    color="primary"
                    variant="flat"
                    class="mt-3"
                    size="small"
                    type="submit"
                >
                    {{ $t("extraFeaturePricesPanel.Update") }}
                </v-btn>
            </form>
        </v-card>
    </authenticated-layout>
</template>

<script>
import AuthenticatedLayout from "@/Layouts/Authenticated";

export default {
    props: {
        extraFeaturePrices: {
            type: Array,
            required: true,
        },
    },
    components: {
        AuthenticatedLayout,
    },
    methods: {
        formatLabel(value) {
            const str = value.replace(/\_/g, " ");

            return str.charAt(0).toUpperCase() + str.slice(1);
        },
        onUpdateExtraFeaturePrices() {
            this.$inertia.patch(
                this.route("extra-feature-prices-panel.update"),
                this.extraFeaturePrices
            );
        },
    },
};
</script>
